import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@sg-bootstrap/components/loader';
defineCustomElements();
export const DropdownPanel = createReactComponent('dropdown-panel');
export const SgAmountInput = createReactComponent('sg-amount-input');
export const SgCategoryPicker = createReactComponent('sg-category-picker');
export const SgCategoryPickerCategory = createReactComponent('sg-category-picker-category');
export const SgCategoryPickerItem = createReactComponent('sg-category-picker-item');
export const SgCategoryPickerLevel = createReactComponent('sg-category-picker-level');
export const SgComponentViewer = createReactComponent('sg-component-viewer');
export const SgCountryPicker = createReactComponent('sg-country-picker');
export const SgCurrencyPicker = createReactComponent('sg-currency-picker');
export const SgDatePicker = createReactComponent('sg-date-picker');
export const SgDatepicker = createReactComponent('sg-datepicker');
export const SgDaterangepicker = createReactComponent('sg-daterangepicker');
export const SgErrorPage = createReactComponent('sg-error-page');
export const SgEventListener = createReactComponent('sg-event-listener');
export const SgI18n = createReactComponent('sg-i18n');
export const SgPagination = createReactComponent('sg-pagination');
export const SgPicker = createReactComponent('sg-picker');
export const SgPlaygroundViewer = createReactComponent('sg-playground-viewer');
export const SgRow = createReactComponent('sg-row');
export const SgShowcaseSwitcher = createReactComponent('sg-showcase-switcher');
export const SgThemeSwitch = createReactComponent('sg-theme-switch');
export const SgTimepicker = createReactComponent('sg-timepicker');
export const SgbsSlider = createReactComponent('sgbs-slider');
